import RegisterExhibitor from './RegisterExhibitor';

export default RegisterExhibitor;
